import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import iconAddSeguimiento from "./iconAddSeguimiento.svg"
import CardSeguimiento from "./CardSeguimiento.jsx";
import DetailContact from "./DetailContact.jsx";
import AgregarContacto from "./AgregarContacto.jsx"
import { getAllsClientes, getClienteById } from "../../endpoints"
import test from "../assets/Animacion-nosotros.webm"
import { useParams } from "react-router-dom";
import CrearCliente from "./CrearCliente.jsx"
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress.jsx"

const Clientes = ({ user }) => {
  const params = useParams();
  // const onlyWidth = useWindowWidth();
  const navigate = useNavigate()
  const [contacts, setContacts] = useState([]);
  const [contactsFilter, setContactsFilter] = useState([]);
  const [seActualizoContacto, setSeActualizoContacto] = useState(false);
  const [openModalObservaciones, setOpenModalObservaciones] = useState(false);
  const [openCreateNuevoCliente, setOpenCreateNuevoCliente] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buscador, setBuscador] = useState();
  const scrollContainerRef = useRef(null);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddSeguimiento, setOpenModalAddSeguimiento] = useState(false);
  const [selectedContact, setSelectContact] = useState();
  const [totalcontactViewer, setTotalcontactViewer] = useState();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ramo: '',
    asesorAsignado: '',
  });

  const openCreateNuevoCliente2 = () => {
    setOpenCreateNuevoCliente(true)
  }
  const closeCreateNuevoCliente = () => {
    setOpenCreateNuevoCliente(false)
  }

  useEffect(() => {
    console.log(selectedContact, "selectedContact")
  }, [selectedContact]);

  const getContactID = async () => {
    getClienteById(params.id).then((response) => {
      if (response.status === 200) {
        console.log(response.data)
        setSelectContact(response.data)
        // Adding a delay of 2 seconds
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        console.log(response)
        setLoading(false)

      }
    })
  }

  useEffect(() => {
    if (params.id) {
      console.log(params.id, "HOLA")
      setLoading(true)
      getContactID()
    }
    console.log(params.id, "HOLA")
  }, [params]);

  const handleNextPage = (currentPage) => {
    if (currentPage <= totalPages) {
      console.log("soy menor")
      let auxCurrent = currentPage + 1;
      setCurrentPage(auxCurrent);
    } else {
    }
  };

  const getContacts = async (buscador) => {
    setLoading2(true);
    getAllsClientes({
      page: currentPage,
      perPage: buscador ? null : 30,
      filterBy: buscador,
      userId: user.id,
      userType: user.type
    }).then((response) => {
      if (response?.status === 200) {
        if (buscador) {
          let newContacts
          if (seActualizoContacto) {
            newContacts = response.data.clientes;
          } else {
            newContacts = [...contacts, ...response.data.clientes];
          }
          setContactsFilter(response.data.clientes)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
        else {
          let newContacts
          if (seActualizoContacto) {
            newContacts = response.data.clientes;
          } else {
            newContacts = [...contacts, ...response.data.clientes];
          }
          setContacts(newContacts);
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total / 30)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }
      } else {
        setLoading2(false)
      }
    });
  };

  useEffect(() => {
    setLoading2(true)
    getContacts(buscador)
  }, [currentPage, buscador]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight) {
        console.log("siguiente pagina")
        console.log(currentPage, "Dentro del scroll")
        handleNextPage(currentPage);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [currentPage, buscador, scrollContainerRef.current]);


  const handlerOpenModal = () => {
    setOpenModal(true);
  }
  const handlerOpenModalSeguimiento = () => {
    setOpenModalAddSeguimiento(true);
  }
  const handlerOpenModalObservaciones = () => {
    setOpenModalObservaciones(true);
  }
  const closeModalObservaciones = () => {
    setOpenModalObservaciones(false);
  }
  const closeModal = () => {
    setOpenModal(false);
  }
  const closeModalAddSeguimiento = () => {
    setOpenModalAddSeguimiento(false);
  }

  const handleChangeBuscador = (e) => {
    const { name, value } = e.target;
    console.log(value)
    console.log(scrollContainerRef, "ASD")
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setBuscador(value);
  };

  const handleFormClick = (e) => {
    e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
  };

  return (
    <ContainerBox >
      <DivContentFilters params={params}>
        <DivRow>
          <DivColumn1>
            <Text1>{`Total: ${totalcontactViewer ? totalcontactViewer : 0}`}</Text1>
          </DivColumn1>
          <DivRow1>
            <BotonCalendar
              onClick={openCreateNuevoCliente2}
            >
              <CalendarIconImg src={iconAddSeguimiento} />
              <div style={{
                width: "auto",
                minWidth: "100%"
              }}>Agregar Cliente</div>
            </BotonCalendar>
          </DivRow1>
        </DivRow>
        <Input
          type="text"
          placeholder="Buscar..."
          value={buscador}
          onChange={handleChangeBuscador}
        />
        <ScrollContainer ref={scrollContainerRef} >
          {contacts && contacts.length > 0 && !buscador ?
            (
              <>
                {contacts.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}

                  />
                ))}
              </>
            ) : (
              <>
                {!buscador ?

                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
          {buscador && contactsFilter && contactsFilter.length > 0 ?
            (
              <>
                {contactsFilter.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}
                  />
                ))}
              </>
            ) : (
              <>
                {buscador ?
                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
        </ScrollContainer>
      </DivContentFilters>
      <DivFlexColumn params={params} >
        {
          openCreateNuevoCliente ?
            <CrearCliente
              user={user}
              stopPropagation={handleFormClick}
              closeCreateNuevoCliente={closeCreateNuevoCliente}
              getClientes={getContacts}
              setClientes={setContacts}
              setSeActualizoContacto={setSeActualizoContacto}
            />
            : null
        }
        {
          openAddContact ?
            <AgregarContacto
              openAddContact={openAddContact}
              setOpenAddContact={setOpenAddContact}
            />
            : null
        }
        {
          loading === false && selectedContact?.id !== undefined ? (
            <DetailContact
              selectedContact={selectedContact}
              formData={formData}
              handlerOpenModal={handlerOpenModal}
              handlerOpenModalObservaciones={handlerOpenModalObservaciones}
              openModalObservaciones={openModalObservaciones}
              openModal={openModal}
              handlerOpenModalSeguimiento={handlerOpenModalSeguimiento}
              closeModalObservaciones={closeModalObservaciones}
              closeModal={closeModal}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              scrollContainerRef={scrollContainerRef}
              setContacts={setContacts}
              closeModalAddSeguimiento={closeModalAddSeguimiento}
              openModalAddSeguimiento={openModalAddSeguimiento}
              user={user}
            />
          ) : loading === false && !selectedContact?.id ? (
            <DivBoxContainer>
              <VideoCont muted autoPlay loop src={test} />
            </DivBoxContainer>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>
    </ContainerBox>

  );
};
const BotonCalendar = styled.div`
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  cursor: pointer;
  margin: 0px 0px 0px 0px;
  align-self: end;
  gap: 8px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #07082c;
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  height: auto;
  border-radius: 8px;
  width: auto;
  min-width: max-content;
  &:focus {
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }
  &:active {
    transform:scale(0.90)
  }
`;

const CalendarIconImg = styled.img`
  max-width:20px;
  max-height:20px;
  width:20px;
  height:20px;
`;

const VideoCont = styled.video`
border-radius: 8px;
height: auto;
width: 50%;
margin: 15%;
`;

const DivBoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width: -webkit-fill-available;
  height: auto;
  justify-content: center;
`;

const DivContentFilters = styled.div`
  width: 25vw;
  min-width:280px;
  max-width: 350px;
  height: auto;
  min-height: 98vh!important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  padding: 0px 0px 8px 24px;
  background-color: #FFFFFF;

  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'none' : 'flex'};
    width: -webkit-fill-available;
  }
`;

const DivFlexColumn = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  width: -webkit-fill-available;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-height: 85vh;
  min-height: 85vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-right: 16px;
  margin-top: 8px;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'flex' : 'none'};
    margin-right: 0px;
  }
`;

const Input = styled.input`
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
  width: -webkit-fill-available;
  min-width: -webkit-fill-available;
  margin: 8px 8px;
  padding:5px;
  border:none;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:26px;
  min-height:26px;
  max-width: 10vw;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #07082c;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
`;

const ContainerBox = styled.div`
  width: -webkit-fill-available;
  height: auto;
  min-height: 95vh;
  max-height: 95vh;
  overflow-y: hidden;
  max-width: calc(100vw - 84px);
  gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1% 16px 0px 1%;
  background-color:#FFFFFF;
  border-radius:8px;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
  @media only screen and (min-width:0px) and (max-width:1100px){
    margin: 5vh 0px 0px 0px;
    max-width: calc(100vw - 0px);
  }
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0.5em 0.5em 0.5em;
  justify-content: space-between;
`;

const DivColumn1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

const DivRow1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5px;
`;

const ScrollContainer = styled.div`
  width: -webkit-fill-available;
  height: auto;
  max-height: calc(100vh - 31vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-top: 2px solid #003049;
  justify-content: flex-start;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
`;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #003049;
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #003049;
`;


export default Clientes;